import React, { useState, useEffect, useCallback } from 'react'
import './App.css'
import { Redirect, useHistory, useLocation } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import ClipLoader from 'react-spinners/ClipLoader'
import { BiMenu } from 'react-icons/bi'
import Header5 from './components/Header5'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import SideNavCust from './layouts/SideNavCust'
import { API_URL } from './config'

const IndexEvents = () => {
  const history = useHistory()
  const location = useLocation()
  const businessName = localStorage.getItem('businessname')
  const businessId = localStorage.getItem('businessid')
  const accounttype = localStorage.getItem('accounttype')

  // --- State Hooks ---
  const [formData, setFormData] = useState({
    eventname: '',
    hostSource: businessName || '',
    externalUrl: '',
    venue: '',
    theme: 'N/A',
    posterUrl: '', // New field
    time: '',
    endtime: '',
    event_date: '',
    finish_date: '',
    description: '',
    eventtype: 'other', // Defaulted since it was missing in your UI
    provinces: 'gauteng', // Defaulted since it was missing in your UI
  })

  const [ui, setUi] = useState({
    error: '',
    errorDisplay: 'none',
    successError: '',
    spinning: 'none',
    updateDisplay: 'block',
    createBtn: 'save-btn',
    isMobile: window.innerWidth <= 768,
    collapsed: window.innerWidth <= 768,
  })

  // --- Helpers ---
  const updateUi = (updates) => setUi((prev) => ({ ...prev, ...updates }))

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    updateUi({ errorDisplay: 'none' })
  }

  // --- Responsive Logic ---
  const updateIsMobile = useCallback(() => {
    const isMobile = window.innerWidth <= 768
    setUi((prev) => ({
      ...prev,
      isMobile,
      collapsed: isMobile ? true : prev.collapsed,
    }))
  }, [])

  useEffect(() => {
    document.title = 'Index External Event / Karamale '
    window.addEventListener('resize', updateIsMobile)
    return () => window.removeEventListener('resize', updateIsMobile)
  }, [updateIsMobile])

  const handleToggle = () => updateUi({ collapsed: !ui.collapsed })

  // --- Submit Logic ---
  const handleUpdate = () => {
    // ... validation logic remains the same ...

    updateUi({ createBtn: 'btn-disabled', spinning: 'block', updateDisplay: 'none' })

    // 1. Create a plain object instead of FormData
    const payload = {
      query: 'INDEX_EXTERNAL',
      accountid: businessId,
      event: formData.eventname,
      customOrganiserName: formData.hostSource,
      external_url: formData.externalUrl,
      venue: formData.venue,
      theme: formData.theme,
      poster_url: formData.posterUrl,
      startdate: formData.event_date,
      enddate: formData.finish_date,
      starttime: formData.time,
      endtime: formData.endtime,
      description: formData.description,
      eventtype: formData.eventtype,
      province: formData.provinces,
    }

    // 2. Send as JSON
    Axios({
      method: 'post',
      url: `${API_URL}/apps/kscanner/index-external-events.php`,
      data: payload, // Sending raw object (Axios converts to JSON)
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (response.data.status === 'success') {
          // 1. Reset the form data to initial values
          setFormData({
            eventname: '',
            hostSource: businessName || '', // Keep the business name if preferred
            externalUrl: '',
            venue: '',
            theme: 'N/A',
            posterUrl: '',
            time: '',
            endtime: '',
            event_date: '',
            finish_date: '',
            description: '',
            eventtype: 'other',
            provinces: 'gauteng',
          })

          // 2. Update UI to show success
          updateUi({
            error: 'Event indexed successfully!',
            errorDisplay: 'block',
            successError: 'success-login',
            createBtn: 'save-btn',
            spinning: 'none',
            updateDisplay: 'block',
          })

          // 3. Optional: Hide the success message automatically after 3 seconds
          setTimeout(() => {
            updateUi({ errorDisplay: 'none' })
          }, 3000)
        } else {
          // Handle server-side error
          updateUi({
            error: response.data.message || 'Failed to index event',
            errorDisplay: 'block',
            successError: 'error-login',
            createBtn: 'save-btn',
            spinning: 'none',
            updateDisplay: 'block',
          })
        }
      })
      .catch((error) => {
        updateUi({
          error: 'Connection Error. Please try again. ' + error.message,
          errorDisplay: 'block',
          successError: 'error-login',
          createBtn: 'save-btn',
          spinning: 'none',
          updateDisplay: 'block',
        })
      })
  }

  if (!businessName) return <Redirect to="/login" />

  const today = new Date().toISOString().split('T')[0]

  return (
    <div className="view">
      {accounttype === 'customer' ? (
        <>
          <SideNavCust collapsed={ui.collapsed} onToggle={handleToggle} />
          <Header />
        </>
      ) : (
        <>
          <SideNav collapsed={ui.collapsed} onToggle={handleToggle} />
          <Header />
        </>
      )}

      <div
        className="container"
        style={{ marginTop: 40, marginLeft: ui.isMobile ? '0px' : 'auto' }}
      >
        {ui.isMobile && !ui.collapsed && (
          <div className="mobile-overlay active" onClick={handleToggle} />
        )}

        {ui.isMobile && ui.collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}

        <div className="row justify-content-center just-container-insid pb-5">
          <div className="col-lg-7 pl-0 pr-0">
            <div className="BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-4 col-6 pl-0 pr-0">
                    <button onClick={() => history.goBack()} className="link-btn">
                      <IoIosArrowBack size={25} />
                      Back &nbsp;
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="BoxDashboardContainer pl-1 pr-1">
              <div className="row align-self-center justify-content-center">
                <div className="col-lg-12 pl-0">
                  <label className="ticket-title pl-2 pr-0">INDEX EXTERNAL EVENTS</label>
                </div>
                <div className="h-divider w-100"></div>
              </div>

              <div className="col-lg-12 details-body">
                <span>Event Details</span>
                <br />
                <br />
                Event Name
                <input
                  type="text"
                  name="eventname"
                  value={formData.eventname}
                  onChange={handleInputChange}
                  className="edit-input form-control"
                />
                <br />
                Host Source
                <input
                  type="text"
                  name="hostSource"
                  placeholder="e.g. Ticketmaster, Facebook"
                  value={formData.hostSource}
                  onChange={handleInputChange}
                  className="edit-input form-control"
                />
                <br />
                External URL
                <input
                  type="text"
                  name="externalUrl"
                  placeholder="https://event-link.com"
                  value={formData.externalUrl}
                  onChange={handleInputChange}
                  className="edit-input form-control"
                />
                <br />
                Venue
                <input
                  type="text"
                  name="venue"
                  value={formData.venue}
                  onChange={handleInputChange}
                  className="edit-input form-control"
                />
                <br />
                Theme
                <input
                  type="text"
                  name="theme"
                  value={formData.theme}
                  onChange={handleInputChange}
                  className="edit-input form-control"
                />
                <br />
                <div className="row">
                  <div className="col-6 pr-2 pl-0">
                    Start Date
                    <input
                      type="date"
                      name="event_date"
                      value={formData.event_date}
                      min={today}
                      onChange={handleInputChange}
                      className="edit-input form-control"
                    />
                  </div>
                  <div className="col-6 pr-0 pl-2">
                    End Date
                    <input
                      type="date"
                      name="finish_date"
                      value={formData.finish_date}
                      min={formData.event_date || today}
                      onChange={handleInputChange}
                      className="edit-input form-control"
                    />
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-6 pr-2 pl-0">
                    Start Time
                    <input
                      type="time"
                      name="time"
                      value={formData.time}
                      onChange={handleInputChange}
                      className="edit-input form-control"
                    />
                  </div>
                  <div className="col-6 pl-2 pr-0">
                    End Time
                    <input
                      type="time"
                      name="endtime"
                      value={formData.endtime}
                      onChange={handleInputChange}
                      className="edit-input form-control"
                    />
                  </div>
                </div>
                <br />
                Add Poster URL
                <input
                  type="text"
                  name="posterUrl"
                  placeholder="https://image-link.com/poster.jpg"
                  value={formData.posterUrl}
                  onChange={handleInputChange}
                  className="edit-input form-control"
                />
                <br />
                Description
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  className="edit-input form-control"
                  rows="4"
                />
              </div>

              <div className="col-12 text-right mt-4">
                <button
                  type="button"
                  className={ui.createBtn}
                  onClick={handleUpdate}
                  disabled={ui.spinning === 'block'}
                >
                  <span style={{ display: ui.updateDisplay }}>Index Event</span>
                  <span style={{ display: ui.spinning }}>
                    <ClipLoader color="grey" loading={true} size={20} />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={ui.successError}
        style={{ display: ui.errorDisplay, textAlign: 'center', cursor: 'pointer' }}
        onClick={() => updateUi({ errorDisplay: 'none' })}
      >
        {ui.error}
      </div>
    </div>
  )
}

export default IndexEvents
